/**
 * Burger King rejection reasons.
 *
 * The screening page saves a BK rejection as the note "{reason} - {remarks}", and the reports
 * Excel splits it back into "Rejection Reason" and "Rejection Remarks" by matching the reason
 * against this list. The two used to keep separate copies: three reasons added to the picker
 * never reached the report, so those rejections exported as reason "Other". One list now.
 */

/** Offered in the reject dialog, in this order. */
export const BK_REJECT_REASONS = [
  'On hold',
  'Female candidate not required',
  'Location issue',
  'Salary expectation is increased',
  'Expected salary exceeded',
  'Candidate dropped',
  'Knowledge gap - inventory',
  "Knowledge gap - SOP's",
  'Knowledge gap - decision making',
  'Knowledge gap - food cost calculation',
];

/** No longer offered, but saved on older rejections — the report must still recognise them. */
const RETIRED_BK_REJECT_REASONS = ['Salary issue'];

const RECOGNISED_REASONS = [...BK_REJECT_REASONS, ...RETIRED_BK_REJECT_REASONS];

/** Splits a saved BK rejection note into its reason and remarks. Unknown reasons read "Other". */
export function parseBkRejectionNote(noteStr) {
  if (!noteStr) return { reason: '', remarks: '' };
  const str = String(noteStr).trim();
  for (const reason of RECOGNISED_REASONS) {
    if (str.startsWith(`${reason} - `)) {
      return { reason, remarks: str.substring(`${reason} - `.length).trim() };
    }
    if (str === reason) {
      return { reason, remarks: '' };
    }
  }
  return { reason: 'Other', remarks: str };
}
